import App from './views/App.vue';
import router from './routes';
import AkReadOnlyLink from "./widgets/AkReadOnlyLink.vue";
import CustomMediaControl from "./widgets/CustomMediaControl.vue";
import AkDatePreview from "./widgets/AkDatePreview.vue";

Vue.component('ak-read-only-link', AkReadOnlyLink);
Vue.component('custom-media-control', CustomMediaControl);
Vue.component('ak-date-preview', AkDatePreview);

let app = new Vue({
        data() { 
            return {
                globalMessages: []
            }
        },
        router,
        render: h => h(App),
}).$mount('#app')

AppKit.init(app);
